function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("rect", {
  x: 11,
  y: 1,
  width: 18,
  height: 20,
  rx: 1,
  fill: "#A8FFF8"
});
var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 4.5,
  cy: 16.5,
  r: 3.5,
  fill: "#CBFF88"
});
var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 4.5,
  cy: 25.5,
  r: 3.5,
  fill: "#CBFF88"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#14454C",
  fillOpacity: 0.15,
  d: "M4 16h18v10H4z"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15 10.5a.5.5 0 01.5-.5h10a.5.5 0 010 1h-10a.5.5 0 01-.5-.5zM18.354 2.646a.5.5 0 010 .708L9 12.707 4.146 7.854a.5.5 0 11.708-.708L9 11.293l8.646-8.647a.5.5 0 01.708 0zM10 17.5a.5.5 0 01.5-.5h15a.5.5 0 010 1h-15a.5.5 0 01-.5-.5zM10 25.5a.5.5 0 01.5-.5h15a.5.5 0 010 1h-15a.5.5 0 01-.5-.5zM4 17.5a.5.5 0 01.5-.5h3a.5.5 0 010 1h-3a.5.5 0 01-.5-.5zM4 25.5a.5.5 0 01.5-.5h3a.5.5 0 010 1h-3a.5.5 0 01-.5-.5z",
  fill: "#14454C"
});
function SvgKeyTakeaways(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 30 30",
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5);
}
export default __webpack_public_path__ + "fonts/key-takeaways-c4db13a1b57fab539168ea4bf65fcab1.svg";
export { SvgKeyTakeaways as ReactComponent };